export const formatAge = (s: number): string => {
  if (s < -60) return 'in future';
  if (s < 60) return 'just now';
  s = s / 60;
  if (s < 60) return Math.floor(s + 0.5) + ' minutes';
  s = s / 60;
  if (s < 24) return Math.floor(s + 0.5) + ' hours';
  s = s / 24;
  if (s < 30) return Math.floor(s + 0.5) + ' days';
  s = s / 30;
  if (s < 12) return Math.floor(s + 0.5) + ' months';
  s /= 12;
  if (s < 40) return Math.floor(s + 0.5) + ' years';
  return '-';
};

export const formatDateAsAge = (d: Date | unknown): string => {
  if (d instanceof Date) {
    const now = new Date();
    return formatAge((now.getTime() - d.getTime()) / 1000);
  } else {
    return '-';
  }
};

/**
 * Format relative time for UI display (e.g., "5 min ago", "2 hrs ago")
 * Used in Maintenance views for "last seen" timestamps
 * @param timestamp - Date string, Date object, or undefined
 * @returns Human-readable relative time string
 */
export const formatRelativeTime = (timestamp: string | Date | undefined): string => {
  if (!timestamp) return 'Never';

  const now = Date.now();
  const then = new Date(timestamp).getTime();
  if (Number.isNaN(then)) return 'Never'; // guard against unparseable input (L-5)
  const diffMs = now - then;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} min ago`;
  if (diffHours < 24) return `${diffHours} hrs ago`;
  return `${diffDays} days ago`;
};
